import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Global Styles"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "global-styles"
    }}>{`Global Styles`}</h1>
    <p>{`Use the Emotion `}<inlineCode parentName="p">{`Global`}</inlineCode>{` component to add global CSS with theme-based values.`}</p>
    <p>{`By default, the `}<inlineCode parentName="p">{`ThemeProvider`}</inlineCode>{` component will apply styles in `}<inlineCode parentName="p">{`theme.styles.root`}</inlineCode>{` to the `}<inlineCode parentName="p">{`<html>`}</inlineCode>{` element.
It will also apply `}<inlineCode parentName="p">{`color`}</inlineCode>{` and `}<inlineCode parentName="p">{`background-color`}</inlineCode>{` styles based on `}<inlineCode parentName="p">{`theme.colors.text`}</inlineCode>{` and `}<inlineCode parentName="p">{`theme.colors.background`}</inlineCode>{` respectively.`}</p>
    <Note mdxType="Note">
  Generally, you should try to avoid adding CSS to global scope. Many styles can
  be safely encapsulated into a component without the need for global styles.
    </Note>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Global } from '@emotion/react'

export default (props) => (
  <Global
    styles={(theme) => ({
      '*': {
        boxSizing: 'border-box',
      },
    })}
  />
)
`}</code></pre>
    <Note mdxType="Note">
      <p>{`  If you are upgrading from a version of theme-ui older that v0.6.0, be aware the import
package has changed from `}<inlineCode parentName="p">{`@emotion/core`}</inlineCode>{` to `}<inlineCode parentName="p">{`@emotion/react`}</inlineCode>{`. For more information see
the `}<a parentName="p" {...{
          "href": "https://theme-ui.com/migrating/#breaking-changes"
        }}>{`Migration Notes for 0.6`}</a>{`.`}</p>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      